import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Button from "../../../../components/UI/Button/Button";
import { useForm } from "react-hook-form";

const LogoutModal = NiceModal.create(() => {
    const modal = useModal();
    const {onClose} = useModalHelper(modal);

    const { handleSubmit } = useForm();
    
    const onSubmit = async () => {
        modal.resolve();
        onClose()
    };

    return (
        <Modal name="logout" id={modal.id} onClose={onClose}>
            <Form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>Logout</Form.Title>
                <Form.Body><p>Do you really want to logout ?</p></Form.Body>
                <Form.Buttons>
                    <Button className="validate" label="Back" onClick={onClose} style={{margin : '10px'}}/>
                    <Button className="cancel" label="Leave" type="submit" style={{margin : '10px'}}/>
                </Form.Buttons>
            </Form>
        </Modal>
    )
});

export default LogoutModal;